/*globals jQuery:false */
// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";

// gsap.registerPlugin(ScrollTrigger);

const DEFAULT_TOP_OFFSET = -40;

class LayeredAnimtion {
	constructor(el) {
		const mobileTest = window.matchMedia("(max-width: 767px)");

		this.isMobile = mobileTest.matches;

		// if at mobile size on js init
		// add class just for this special case
		// abort. no need to do any more js (no animations)
		if (this.isMobile && "ontouchstart" in window) {
			el.classList.add("layered-animation-section--mobile-init");
			return;
		}

		this.el = el;

		// store references to our dom elements
		this.dom = {
			el,
			//bounds: el.getBoundingClientRect(),
			bottom: el.querySelectorAll(".layered-animation__background-bottom"),
			top: el.querySelectorAll(".layered-animation__background-top"),
			content: el.querySelectorAll(".layered-animation__content"),
		};

		this.topOffset = DEFAULT_TOP_OFFSET;

		// check el for top offset override data prop
		if (Object.prototype.hasOwnProperty.call(this.el.dataset, "topOffset")) {
			const to = parseInt(this.el.dataset.topOffset, 10);
			if (!isNaN(to)) {
				this.topOffset = to;
			}
			//console.log('el to prop', this.el.dataset.topOffset, to, this.topOffset);
		}

		// set wether or not the content should be immediately visible or fade in at end of animation
		this.fadeContent = true;

		// check el for fade-content data prop and override default fadeContent value
		if (Object.prototype.hasOwnProperty.call(this.el.dataset, "fadeContent")) {
			this.fadeContent = this.el.dataset.fadeContent === "true";
		}

		// the anime
		this.animeTl = gsap.timeline({
			paused: true,
			//scrollTrigger: this.scrollTrigger,
			ease: "sine.inOut",
		});

		// the scrollTrigger
		// timeline is added to trigger, then tweens are added to tl
		this.scrollTrigger = ScrollTrigger.create({
			animation: this.animeTl,
			trigger: el,
			//toggleActions: 'restart pause reverse pause',
			start: "top bottom", // triggerpos viewportpos
			end: "bottom bottom", // triggerpos viewportpos
			//markers: true, // debug only
			scrub: 3, // 1s delay buffer,
		});

		if (this.isMobile) {
			this.scrollTrigger.disable();
		} else {
			this.runAnime();
		}

		// event listeners
		mobileTest.addListener(this.mobileTestUpdate.bind(this));
	}

	// if we have inited our animation js but the browser goes mobile or vice versa
	// clear anime and disable or enable scrollTrigger
	mobileTestUpdate(test) {
		this.isMobile = test.matches;

		console.log("mobileTestUpdate", this.isMobile);

		// on change to mobile size
		// disable scrollTrigger
		// complete the animation to set everything in natural position, props
		// remove anime tweens
		if (this.isMobile) {
			this.scrollTrigger.disable(true, true);
			this.animeTl.progress(1);
			this.animeTl.clear();

			// on change to desktop
			// enable scrollTrigger
			// add tweens to timeline
		} else {
			this.animeTl.clear();
			this.scrollTrigger.enable();
			this.runAnime();
		}
	}

	// add tweens to timeline
	runAnime() {
		if (this.fadeContent) {
			this.animeTl
				.fromTo(this.dom.bottom, { opacity: 0.2 }, { opacity: 1, duration: 5, delay: 2 }, "bg")
				.fromTo(this.dom.top, { yPercent: this.topOffset }, { yPercent: 0, duration: 5, delay: 1 }, "bg")
				.fromTo(this.dom.content, { display: "block", opacity: 0, duration: 1 }, { opacity: 1 });
		} else {
			this.animeTl
				.set(this.dom.content, { display: "block", opacity: 1 })
				.fromTo(this.dom.bottom, { opacity: 0.2 }, { opacity: 1, duration: 5, delay: 2 }, "bg")
				.fromTo(this.dom.top, { yPercent: this.topOffset }, { yPercent: 0, duration: 5, delay: 1 }, "bg");
		}
	}
}

jQuery(document).ready(function () {
	let i;

	let layeredAnimes = document.querySelectorAll(".layered-animation-section");

	for (i = 0; i < layeredAnimes.length; i++) {
		new LayeredAnimtion(layeredAnimes[i]);
	}
});
